import { connect } from 'react-redux';
import { HomeComponent } from '../../components';

const mapStateToProps = state => ({
  user: state.auth.user
})

const mapDispatchToProps = { };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeComponent)



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js